import { leaders4 } from './leaders.js'
import './App.css';
import React from 'react'
import dd from './imgs/dd.png'
import discord from './imgs/discord.png'
import tg from './imgs/icon--telegram.png'
import x from './imgs/icon--twitter.png'
import bg from './imgs/leaders4.gif'
function App() {
  const searchRef = React.createRef()
  const [searchResults, setSearchResults] = React.useState([])


  const search = () => {
    let searchTerm = searchRef.current.value
    console.log("Searching for: ",searchTerm)
    let leader
    let selected = []
    let count = 0
    for (let i = 0; i < leaders4.length; i++) {
      leader = leaders4[i]
      if (leader[0].indexOf(searchTerm.toLowerCase()) > -1) {
        selected[count] = i
        count++
      }
    }
    setSearchResults(selected)
  }
  return (
    <div className="App">
    <img src={bg} className="lander" />
    <div className="inner">
      <h2>Search Your Address</h2>
      <div className="search">
        <input ref={searchRef} />
        <button onClick={search}>Search</button>
      </div>
      <div className="search-results">
        {
          searchResults.map((searchResult,index)=>(
            <div key={"result"+index} className="result">
              <span>Rank {searchResult + 1}: </span>
              <span className="leader">
                {leaders4[searchResult][0].substring(0,5)}...{leaders4[searchResult][0].substring(leaders4[searchResult][0].length-5)} // 
              </span>
              <span className="score">
               {leaders4[searchResult][1]}
              </span>
            </div>
            ))
        }
      </div>
      <h2>Full List of Participants</h2>
      <ol className="leaderboard">
        {
          leaders4.map((leader,index)=>(
            <li key={"row"+index} className="row">
              <span className="leader">
                {leader[0].substring(0,5)}...{leader[0].substring(leader[0].length-5)} // 
              </span>
              <span className="score">
                {leader[1]}
              </span>
            </li>
            ))
        }
      </ol>
      <div className="dd"><img src={dd}/></div>
      
          </div>
          <div className="links">
     
            <a href="https://discord.gg/3BUen4F9Tw" target="_blank"><img src={discord} /></a>
            
            <a href="https://t.me/derpedewdz" target="_blank"><img src={tg}/></a>
            
            <a href="https://x.com/derpedewdz" target="_blank"><img src={x}/></a>
     
          </div>
    </div>
  );
}

export default App;
